module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODciIGhlaWdodD0iMTg3IiB2aWV3Qm94PSIwIDAgMTg3IDE4NyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiMwMDg0RkYiIHN0cm9rZS1vcGFjaXR5PSIuMzA3IiBvcGFjaXR5PSIuOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjg1NyAuOTI5KSI+PGNpcmNsZSBjeD0iMjE4LjUiIGN5PSIyMTEuNSIgcj0iNjAuNSIgb3BhY2l0eT0iLjQiLz48Y2lyY2xlIGN4PSItNzkuOTY0IiBjeT0iNy4wMzYiIHI9IjE2NS4wMzYiIG9wYWNpdHk9Ii40Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/service-bg-2.svg
// module id = 84
// module chunks = 35783957827783 79611799117203 85929988179075 182101406987512